import { render, staticRenderFns } from "./RegiaoTabela.vue?vue&type=template&id=1ed0839a&lang=html"
import script from "./RegiaoTabela.vue?vue&type=script&lang=js"
export * from "./RegiaoTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports